import { Button } from 'components/Button';
import { Dialog } from '@headlessui/react';
import Modal from 'components/Modal';
import Stack from 'components/Stack';
import { UpgradeToSpateProLink } from 'components/NoAccessMessage';
import styled from 'styled-components';

const RedirectMessageHeader = styled(Stack).attrs(
    ({ as = 'header', $space = '.5rem' }) => ({
        as,
        $space,
    }),
)`
    && {
        border-bottom: 0;
    }
`;

function TikTokProFeatureModal(props) {
    return (
        <Modal {...props}>
            <RedirectMessageHeader>
                <Dialog.Title>Filter &amp; Sort</Dialog.Title>
                <Dialog.Description>
                    This feature is only available for Spate Pro clients.
                    Upgrade your subscription to use filtering and sorting.
                </Dialog.Description>
            </RedirectMessageHeader>
            <Stack as="footer" $direction="row" $space="6px">
                <Button intent="secondary" onClick={() => props.onClose()}>
                    Not Now
                </Button>
                <UpgradeToSpateProLink className="px-6 py-2 !text-primary-foreground !no-underline hover:!text-primary-foreground hover:!no-underline" />
            </Stack>
        </Modal>
    );
}

export default TikTokProFeatureModal;
